import React from "react";
import Modal from "./Modal";
import PackagesTab from "./PackagesTab";

/**
 * Public, no-login-required showcase of the loyalty packages — reuses the
 * exact same PackagesTab content shown inside "Můj účet" so pricing/copy
 * never drifts between the two, but wraps it in the standard Modal (smooth
 * spring-in animation, blurred backdrop, X + click-outside to close).
 */
export default function PackagesShowcaseModal({ open, onClose }) {
  return (
    <Modal open={open} onClose={onClose} title="Výhodné balíčky" size="xl" testId="packages-showcase-modal">
      <PackagesTab />
    </Modal>
  );
}
